import type { FaireProductEntity } from "../../entity_types/product";

export const p_phzknxfsc4: FaireProductEntity = {
  token: "p_phzknxfsc4",
  type: "product",
  name: "Swedish Dishcloth - Plain / Unprinted Assorted Colors",
  brandToken: "b_qvptz4nibr",
  brandName: "Trendy Tripper",
  imageUrl:
    "https://cdn.faire.com/fastly/d42c354e5f429e6e115a646f6741ea0674941b78e604360bc3cbdd4313154014.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4da6c2f8464efdc4bcdbbcb395d319216b43c6afb8d0efcef9589c40eab9dce.jpeg",
    "https://cdn.faire.com/fastly/d03b2138730d79b79b6d63b599c312c6469d12509f71b50b4060a6e6a03cbb51.jpeg",
    "https://cdn.faire.com/fastly/1a0490c2ac20fb206067c80d81c4c47683f0912bf2e0196ab21a96fceafcdc18.jpeg",
    "https://cdn.faire.com/fastly/959d379728d43369d115bb2864cc0c4c4d6153ae4c0a280477ec1ef3abb877ff.jpeg",
    "https://cdn.faire.com/fastly/b42f7e4d9e5a0d584c54378fb835ee9670b4b01dd53219c90ba2a803ebdba9b5.jpeg",
    "https://cdn.faire.com/fastly/441625a862134a8f709c2b6ba2c1db070b016932dc17dc72e2da1ff67b7507dd.jpeg",
    "https://cdn.faire.com/fastly/db105987ac062220083e38b50d584f716a1f7644649f42140f01e52d32a43670.jpeg",
    "https://cdn.faire.com/fastly/ebb4d5fb3e7ac72e1bc8af020d1dbf330c9ed415fcbe3b95587f1bf4764d736b.jpeg",
    "https://cdn.faire.com/fastly/a4b323474fe1b4deb1e47e180c6fef9f9b15a4bdf3bdb89afc47462c7cfaf803.jpeg",
    "https://cdn.faire.com/fastly/a50757dfb2ede85aad78e55e55986a7ca8ed55f66189f71439ae3318cf011096.jpeg",
  ],
  priceDollars: 1.1,
  description:
    'EARTH-FRIENDLY REUSABLE, COMPOSTABLE SWEDISH SPONGE CLOTHS (aka Swedish Dishcloth) made in Germany.\nMade up of all natural fiber which is 100% compostable. Absorbs 15x its weight in water. One cloth replaces 15 rolls paper towel saving money and our planet. Use to wipe produce, household surfaces, granite, glass, appliances, pet paws and more! Typically good for 200 wash cycles. In the end, cut up and compost. When dry the cloth is stiff but when wet is soft like a chamois and dries quickly helping to be odor resistant helping to keep your kitchen fresh and clean. Always rinse before first use.\nReusable, washable + sustainable = zero waste cleaning cloth that will freshen the look of the kitchen while being nice to our planet!\nRetro flower design illustrated by Jenn Ski exclusively for Trendy Tripper.\nSize: 8" x 6.75".  \n70% plant-based cellulose pulp + 30% recycled cotton. Machine washable. Package-free.',
  tags: [],
  msrpDollars: 2.2,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:42.106Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
